import React, { useCallback, useEffect, useState } from 'react';
import {
  useTable, usePagination, useSortBy, useFilters,
} from 'react-table';
import _ from 'lodash';

import TableUI from '../utils/ContainerTableUI';

export default React.memo( ( {
  data, columns, Filters, total, onFetchData, defaultPageSize = 10, disableSorting = false,
  defaultSortBy = [], getRowProps, ...rest
} ) => {
  const [filters, setFilterDefault] = useState( {} );
  const [controlledPageCount, setControlledPageCount] = useState(
    Math.ceil( total / defaultPageSize ),
  );

  const {
    getTableProps, headerGroups, page, prepareRow, gotoPage,
    canPreviousPage, previousPage, canNextPage, nextPage, setPageSize,
    state: { pageIndex, sortBy, pageSize },
  } = useTable( {
    data,
    columns: React.useMemo(
      () => columns,
      [columns],
    ),
    disableSorting,
    initialState: { pageSize: defaultPageSize, sortBy: defaultSortBy },
    manualFilters: true,
    manualPagination: true,
    manualSortBy: true,
    pageCount: controlledPageCount,
  }, useFilters, useSortBy, usePagination );

  useEffect( () => {
    setControlledPageCount( Math.ceil( total / pageSize ) );
  }, [total, pageSize] );

  const setControlledPageSizeFn = useCallback( ( size ) => {
    setPageSize( size );
    setControlledPageCount( Math.ceil( total / size ) );
  }, [total, setPageSize] );

  const setFilter = ( column, value ) => {
    const newFilter = {};
    newFilter[column] = value;
    if ( pageIndex > 0 ) {
      gotoPage( 0 );
    }
    setFilterDefault( { ...filters, ...newFilter } );
  };

  const setMultipleFilters = ( newFilters ) => {
    if ( pageIndex > 0 ) {
      gotoPage( 0 );
    }
    setFilterDefault( { ...filters, ...newFilters } );
  };

  React.useEffect( () => {
    const apiParams = {
      offset: pageIndex * pageSize,
      limit: pageSize,
    };
    if ( sortBy && sortBy.length ) apiParams[`sortby[${sortBy[0].id}]`] = sortBy[0].desc ? 'DESC' : 'ASC';
    if ( filters ) _.map( filters, ( filter, key ) => { apiParams[`filters[${key}]`] = filter; } );
    onFetchData( apiParams );
  }, [onFetchData, pageIndex, pageSize, sortBy, filters] );

  return (
    <TableUI
      {...rest}
      getTableProps={getTableProps}
      getRowProps={getRowProps}
      headerGroups={headerGroups}
      page={page}
      prepareRow={prepareRow}
      gotoPage={gotoPage}
      canPreviousPage={canPreviousPage}
      canNextPage={canNextPage}
      previousPage={previousPage}
      nextPage={nextPage}
      pageIndex={pageIndex}
      pageCount={controlledPageCount}
      setPageSize={setControlledPageSizeFn}
      pageSize={pageSize}
      filters={filters}
      setFilter={setFilter}
      setMultipleFilters={setMultipleFilters}
      CustomFilters={Filters}
    />
  );
} );
